import Instruments from 'ff/debrief/components/instruments/instruments';
export default Instruments;
